import { c as _c } from "react/compiler-runtime";
import { mainnet } from "viem/chains";
import { MEMES_CONTRACT } from "@/constants/constants";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { getDimensionsFromMetadata, getFileMimeTypeFromMetadata, getFileTypeFromMetadata } from "@/helpers/nft.helpers";
import NowMintingCountdown from "./NowMintingCountdown";
import NowMintingDetailsAccordion from "./NowMintingDetailsAccordion";
import NowMintingHeader from "./NowMintingHeader";
import NowMintingStatsGrid from "./NowMintingStatsGrid";
import LatestDropNextMintSubscribe from "./LatestDropNextMintSubscribe";
interface NowMintingDetailsProps {
  readonly nft: NFTWithMemesExtendedData;
}
export default function NowMintingDetails(t0) {
  const $ = _c(30);
  const {
    nft
  } = t0;
  const formatEth = _temp;
  const floorPrice = formatEth(nft.floor_price);
  let t1;
  if ($[0] !== nft.metadata) {
    t1 = getFileMimeTypeFromMetadata(nft.metadata);
    $[0] = nft.metadata;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fileMimeType = t1;
  let t2;
  if ($[2] !== fileMimeType || $[3] !== nft.artist || $[4] !== nft.artist_seize_handle || $[5] !== nft.id || $[6] !== nft.name) {
    t2 = <NowMintingHeader cardNumber={nft.id} title={nft.name} artistHandle={nft.artist_seize_handle} artistName={nft.artist} mediaMimeType={fileMimeType} />;
    $[2] = fileMimeType;
    $[3] = nft.artist;
    $[4] = nft.artist_seize_handle;
    $[5] = nft.id;
    $[6] = nft.name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== floorPrice || $[9] !== nft.id) {
    t3 = <NowMintingStatsGrid nftId={nft.id} floorPrice={floorPrice} />;
    $[8] = floorPrice;
    $[9] = nft.id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LatestDropNextMintSubscribe showOnlyWhenSubscribed={true} readonly={true} />;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = nft.id;
  const t6 = nft.mint_date;
  let t7;
  if ($[12] !== nft.metadata) {
    t7 = getFileTypeFromMetadata(nft.metadata);
    $[12] = nft.metadata;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== nft.metadata) {
    t8 = getDimensionsFromMetadata(nft.metadata);
    $[14] = nft.metadata;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== nft.collection || $[17] !== nft.id || $[18] !== nft.mint_date || $[19] !== nft.season || $[20] !== t7 || $[21] !== t8) {
    t9 = <NowMintingDetailsAccordion nftId={t5} mintDate={t6} fileType={t7} dimensions={t8} collection={nft.collection} season={nft.season} />;
    $[16] = nft.collection;
    $[17] = nft.id;
    $[18] = nft.mint_date;
    $[19] = nft.season;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== nft.id) {
    t10 = <NowMintingCountdown nftId={nft.id} contract={MEMES_CONTRACT} chainId={mainnet.id} />;
    $[23] = nft.id;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t2 || $[27] !== t3 || $[28] !== t9) {
    t11 = <div className="tw-w-full"><div className="tw-flex tw-flex-col tw-gap-5">{t2}{t3}{t4}{t9}{t10}</div></div>;
    $[25] = t10;
    $[26] = t2;
    $[27] = t3;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function _temp(value) {
  if (value <= 0) {
    return "N/A";
  }
  return `${Number.parseFloat(value.toFixed(5))} ETH`;
}